import { createContext, useContext, ReactNode } from 'react';
import { StyleProvider } from '@ant-design/cssinjs';

interface StyleContainerProviderProps {
	container?: HTMLHeadElement | ShadowRoot;
	children: ReactNode;
}

const StyleContainerContext = createContext<Omit<StyleContainerProviderProps, 'children'>>({
	container: document.head
});

export const StyleContainerProvider = ({
	container = document.head,
	children
}: StyleContainerProviderProps) => {
	const contextValue = { container };

	return (
		<StyleContainerContext.Provider value={contextValue}>
			<StyleProvider
				container={container}
			>
				{children}
			</StyleProvider>
		</StyleContainerContext.Provider>
	);
};

export const useStyleContainer = () => {
	return useContext(StyleContainerContext);
};
